// WE NEED TO TRACK LOCAL STORAGES VALUES
// WE DON'T WANT TO ALLOW DEVELOPERS TO PUT RANDOM/UNTRACK LOCAL STORAGES VALUES
export enum LocalStorageKeys {
  PICKLISTS = 'picklists',
  ACCESS_TOKEN = 'authce9d77b308c149d5992a80073637e4d5',
  REFRESH_TOKEN = 'authre9d77b308c149d5992a80073637e4d5',
  SELECTED_CAMERA_DEVICE = 'selected_camera_device',
  SALES_ORDER_FILTERS_SORTINGS = 'sales_order_filters_sortings',
  SALES_ORDER_COLUMNS_VISIBLE = 'sales_order_columns_visible',
  SALES_ORDER_TABLE_PAGINATION = 'sales_order_table_pagination',
  SALES_ORDER_AG_STATE = 'sales_order_ag_state',
  SALES_ORDER_AG_GROUP_STATE = 'sales_order_ag_group_state',
  WAREHOUSE_APP_ACTIVE_DEVICE_ID_KEY = 'luminous_app_scanner_device_id',
  CHANNEL_PRODUCT_MAPPING_PAGE_STATE = 'channel_product_mapping_page_state',
  STOCK_SNAPSHOT_COLUMN_STATE = 'stock_snapshot_column_state',
  STOCK_SNAPSHOT_FILTER_STATE = 'stock_snapshot_filter_state',
  INVOICING_FORM_COLUMN_STATE = 'invoicing_form_column_state',
  STOCK_TABLE_PAGINATION = 'stock_table_pagination',
  STOCK_AG_STATE = 'stock_ag_state',
  STOCK_AG_GROUP_STATE = 'stock_ag_group_state',
  STOCK_AG_SIDEBAR_STATUS = 'stock_ag_sidebar_status',
  SALES_ORDER_LINE_ITEM_FORM_COLUMN_STATE = 'sales_order_line_item_form_column_state',
  SALES_ORDER_VIEW_SETTINGS = 'lum:settings:view:SalesOrder',
  INVOICE_AG_STATE = 'invoice_ag_state',
  SHIPMENTS_AG_STATE = 'shipments_ag_state',
  COST_LAYERS_VIEW_SETTINGS = 'lum:settings:view:CostLayers',
  ACCOUNTING_DASHBOARD_VIEW_SETTINGS = 'lum:settings:view:AccountingDashboard',
  FULFILLMENT_ORDERS_AG_STATE = 'fulfillment_orders_ag_state',
  FULFILLMENT_PRIORITY_LIST_AG_STATE = 'fulfillment_priority_list_ag_state',
}
